<div class="metric-settings-editor">
  <div class="col-md-3 side-nav-col">
    <metric-settings-editor-side-nav
      [metrics]="metrics?.allMetrics"
      [selectedMetricForCustomer]="metrics?.updatedSelectedMetric"
      (selectNewMetric)="selectNewMetricForCustomer($event)"
    ></metric-settings-editor-side-nav>
  </div>
  <div class="col-md-6">
    <metric-settings-editor-form
      [metrics]="metrics"
      (metricNameEvent)="metricNameUpdated($event)"
      (metricDescEvent)="metricDescUpdated($event)"
      (saveChangesEvent)="updateMetric()"
    >
    </metric-settings-editor-form>
    <hr class="metric-settings-hr" />
    <other-reports-url-config
      [metric]="metrics?.updatedSelectedMetric"
      [hasChangesToSave]="metrics?.changesToSave?.otherReportsUrl"
      [pending]="metrics?.pending"
      [savedSuccessfully]="metrics?.savedSuccessfully?.otherReportsUrl"
      [error]="metrics?.errors?.otherReportsUrl"
      [isStarter]="isStarter"
      (otherReportsUrlChanged)="otherReportsUrlChanged($event)"
      (saveOtherReportsUrl)="saveOtherReportsUrl()"
    ></other-reports-url-config>
    <hr class="metric-settings-hr" />
    <metric-settings-goals
      [goals]="goals | async"
      [schools]="schools | async"
      [metric]="metrics?.updatedSelectedMetric"
      [district]="district | async"
      (goalValueChanged)="goalValueChanged($event)"
      (goalInactiveChecked)="goalInactiveChecked($event)"
      (filterGoalValueChanged)="filterGoalValueChanged($event)"
      (filterGoalInactiveChanged)="filterGoalInactiveChanged($event)"
      (applyFilterGoal)="applyFilterGoal($event)"
      (schoolLevelSelected)="schoolLevelSelected($event)"
      (saveGoalsClicked)="saveGoalsClicked()"
    ></metric-settings-goals>
  </div>
  <div class="col-md-3">
    <metric-settings-preview
      [metric]="metrics?.updatedSelectedMetric"
      [selectedMetricData]="metrics?.selectedMetricData"
      [district]="district | async"
      [goals]="goals | async"
    ></metric-settings-preview>
  </div>
</div>
